var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Block',{attrs:{"title":'Catering',"items":_vm.items}},[_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }